/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {
    Fragment,
    useState
} from '@wordpress/element';
/**
* Internal dependencies
*/
import {VayuBlocksHeaderTab,usePanelSettings} from '@vayu-blocks';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import SwiperSettingPanel from './settings/index.js';
import SwiperStylePanel from './style/index.js';

const panelKeys = [
	'vb-swiper-set',
	'vb-swiper-nav',

	'vb-swiper-nav-style',
	'vb-swiper-pagi-style',
	
];

const initialPanels = {
	setting: 'vb-swiper-set',
	style:'',
	advanced: '',
};

const panelOptions = [
	{ label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand'},
	{ label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = (props) => {

    const {
        attributes,
        setAttributes,
        clientId
    } = props;

    const { tab, setTab, openPanels, onTogglePanel  } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });
    const tabComponents = {
		    setting: <SwiperSettingPanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel} />,
			style: <SwiperStylePanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
			advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
    const ANCHOR_REGEX = /[\s#]/g;

    return (
        <Fragment>
        <InspectorControls>
        <div className='th-block-ins'>
          <VayuBlocksHeaderTab 
                                        value={ tab }
                                        options={panelOptions}
                                        onChange={ setTab }
                                    />
                                
                                {tabComponents[tab]}
         </div>
        </InspectorControls>
        </Fragment>
    );

}
export default InsSettings;